import {Component, inject, OnInit} from '@angular/core';
import {IndexIoService} from '../../services/index-io.service';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {NgForOf, NgIf} from '@angular/common';


@Component({
  selector: 'bnpp-indx-search',
  imports: [
    NgIf,
    NgForOf,
    RouterLink
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  standalone: true
})
export class SearchComponent implements  OnInit{
  private indexInfoService = inject(IndexIoService);
  indexSearchInfo = this.indexInfoService.indexSearchInfo;
  searchTerm:string='';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.searchTerm = params['term'];
      this.indexInfoService.getSearchResults(this.searchTerm);
    });
  }
}
